var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.sortedFields.length
        ? _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _vm._l(_vm.sortedFields, function(field) {
                return [
                  _c("field-input", {
                    key: field.id,
                    ref: "field",
                    refInFor: true,
                    attrs: {
                      assignment_type: _vm.assignment_type,
                      assignment_id: _vm.assignment_id,
                      availableassignments: _vm.availableassignments
                        ? _vm.availableassignments[field.id]
                        : null,
                      column: _vm.columns[field.internal_name],
                      field: field,
                      inlineEdit: _vm.inlineEdit,
                      inlineSave: _vm.inlineSave,
                      keyedFieldvalues: _vm.keyedFieldvalues,
                      overrideConfig: _vm.overrides
                        ? _vm.overrides[field.id]
                        : null,
                      setDefault: _vm.setDefault,
                      value: _vm.keyedFieldvalues[field.id],
                      viewform: _vm.viewform,
                      editDisabled: _vm.editDisabled
                    },
                    on: {
                      inputChanged: function($event) {
                        return _vm.$emit("inputChanged", $event)
                      },
                      createCustomer: function($event) {
                        return _vm.$emit("createCustomer", $event)
                      }
                    }
                  })
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.sortedFieldGroups, function(value, key, index) {
        return [
          _vm.sortedFields.length || index > 0
            ? _c("v-divider", { key: index, staticClass: "my-4" })
            : _vm._e(),
          _vm._v(" "),
          key !== "fields" && value.fields.length
            ? _c(
                _vm.card ? "v-card-text" : "span",
                { key: "c" + key, tag: "component" },
                [
                  _c("div", { staticClass: "headline" }, [
                    _vm._v("\n\t\t\t\t\t" + _vm._s(value.title) + "\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _vm._l(value.fields, function(field) {
                        return [
                          _c("field-input", {
                            key: field.id,
                            attrs: {
                              assignment_type: _vm.assignment_type,
                              assignment_id: _vm.assignment_id,
                              availableassignments: _vm.availableassignments
                                ? _vm.availableassignments[field.id]
                                : null,
                              column: _vm.columns[field.internal_name],
                              field: field,
                              inlineEdit: _vm.inlineEdit,
                              inlineSave: _vm.inlineSave,
                              keyedFieldvalues: _vm.keyedFieldvalues,
                              overrideConfig: _vm.overrides
                                ? _vm.overrides[field.id]
                                : null,
                              setDefault: _vm.setDefault,
                              value: _vm.keyedFieldvalues[field.id],
                              viewform: _vm.viewform,
                              editDisabled: _vm.editDisabled
                            },
                            on: {
                              inputChanged: function($event) {
                                return _vm.$emit("inputChanged", $event)
                              },
                              createCustomer: function($event) {
                                return _vm.$emit("createCustomer", $event)
                              }
                            }
                          })
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-024ec042", { render: render, staticRenderFns: staticRenderFns })
  }
}